import React, { useState } from 'react';

import cn from 'classnames';
import dynamic from 'next/dynamic'

import { THEME } from '@constants/index';
import { Button, openModal } from '@element/index'
import { I18n } from '@utils/index';

import { ModalTitle } from '../ModalTitle'

import styles from './index.module.less';

const CodeInput = dynamic(() => import('@components/index').then(modal => modal.CodeInput), { ssr: false });

export interface MainProps {
  close: () => void;
  resolve: (value: string) => void;
  /** 点击忘记密码 */
  onForgetPwd?: (close: MainProps['close'], resolve: MainProps['resolve']) => void;
  /** 输入完成 */
  onComplete: (value: string) => Promise<{ errorText?: string; status?: 'DONE' }>;
  theme?: Theme;
}

const Main: React.FC<MainProps> = (props) => {
  const { onForgetPwd, onComplete, close, resolve, theme = THEME.HIGHLIGHT } = props;
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorText, setErrorText] = useState('')
  const onFulfill = async (value: string) => {
    setLoading(true)
    const res = await onComplete(value);
    setLoading(false);
    if (res.errorText) {
      setErrorText(res.errorText);
    }
    if (res.status === 'DONE') {
      close()
      resolve(value);
    }
  }
  const onChange = (value: string) => {
    setValue(value);
    setErrorText('');
  }
  return (
    <div className={styles.container}>

      <CodeInput
        type="password"
        theme={theme}
        status={errorText ? 'error' : undefined}
        className={styles.codeInput}
        autocomplete="new-password"
        inputMode='numeric'
        // readonly="true"
        // onComplete={onFulfill}
        onChange={onChange}
      />
      {!!errorText && <p className={styles.error}>{errorText}</p>}
      {!!onForgetPwd && (
        <p className={cn(styles.btn, 'Medium', {
          [styles.darkBtn]: theme === THEME.DARK
        })} data-buried="forgot-asset-password" onClick={() => onForgetPwd(close, resolve)}>
          {I18n.t('forgetPass_step_one_forget')}
        </p>
      )}
      <div className={styles.footer}>
        <Button
          type="primary"
          loading={loading}
          onClick={() => onFulfill(value)}
          className={styles.btn}
          borderRadius={8}
          disabled={value?.length < 6}
          data-buried="complete-asset-password-input"
        >{I18n.t('xszwnDwR')}</Button>
      </div>
    </div>
  );
}

interface OpenSetPasswordReq extends Omit<MainProps, 'close' | 'resolve'> {
  /** 点击X关闭的勾子 */
  closeHook?: () => Promise<'ok' | 'cancel'>;
  title: string;
  subTitle?: string;
}

export const openSetPassword = (params: OpenSetPasswordReq): Promise<'ok' | string> => {
  const { closeHook, title, subTitle = I18n.t('9AlAm574') } = params
  return new Promise((resolve) => {
    openModal({
      title: <ModalTitle title={title} subTitle={subTitle} />,
      theme: params.theme,
      onClose: (close) => async () => {
        if (!closeHook) {
          close()
          resolve('cancel');
          return
        }

        const res = await closeHook();
        if (res === 'ok') {
          close()
          resolve('cancel');
        }
      },
      dataBuried: 'close-asset-password',
      children: (close) => (
        <Main close={close} resolve={resolve} {...params} />
      ),
      footer: null
    })
  })
}
